import React, { useMemo } from 'react';

const useParameterTextWithArea = (entityField) => {
  const text = useMemo(
    () =>
      entityField ? (
        <>
          {entityField} м<sup>2</sup>
        </>
      ) : (
        '-'
      ),
    [entityField]
  );

  return text;
};

export default useParameterTextWithArea;
